import { hasCapability, PREMIUM_DRAWING_TYPES } from "@vninvestcharts/engine-core";
/**
 * SSOT: `PREMIUM_DRAWING_TYPES` + `hasCapability` trong engine-core
 * (`src/patTier.ts` / `src/capabilities.ts`).
 *
 * TRƯỚC ĐÂY file này giữ **bản copy cục bộ** của danh sách 16 tool với lý do
 * "tsup DTS can't export const arrays" — nhưng lý do đó đã hết hiệu lực:
 * engine-core đã force-bundle qua `src/adEnforcement.ts` (import trực tiếp trong index.ts),
 * và `patTier.ts:30,49` đều là `export const`. Bản copy chỉ tạo rủi ro trôi dạt.
 * Bỏ copy ở W0.2 (PLAN_FRONTEND_PROPLUS_TRACKA_2026-09-28 §2.1).
 *
 * 2026-10-22 (decision D2): `smart_drawing_pro` → Community, so the check below can
 * no longer block anything. The function is KEPT — it is where a future Pro drawing
 * set plugs in, and `PREMIUM_DRAWING_TYPES` is still the registry of the TIER-16 set.
 */
function isPremiumTool(toolType) {
    return PREMIUM_DRAWING_TYPES.includes(toolType);
}
export function isToolAvailable(toolType, currentTier) {
    if (!isPremiumTool(toolType))
        return true;
    return hasCapability(currentTier, "smart_drawing_pro");
}
